import type { Metadata } from "./minidisc-labeler";

export const defaultMetas: Metadata[] = [
    {
        artist: "glass beach",
        album: "the first glass beach album",
        year: "2019",
        artURL: new URL("../images/glass-beach.jpg", import.meta.url).href,
    },
    {
        artist: "dogleg",
        album: "melee",
        year: "2020",
        artURL: new URL("../images/dogleg.jpg", import.meta.url).href,
    },
    {
        artist: "origami angel",
        album: "somewhere city",
        year: "2019",
        artURL: new URL("../images/somewhere-city.jpg", import.meta.url).href,
    },
    {
        artist: "長谷川白紙",
        album: "草木萌動",
        year: "2018",
        artURL: new URL("../images/somoku-hodo.jpg", import.meta.url).href,
    },
    {
        artist: "my chemical romance",
        album: "three cheers for sweet revenge",
        year: "2004",
        artURL: new URL("../images/three-cheers.jpg", import.meta.url).href,
    },
    {
        artist: "DV-i",
        album: "implementation",
        year: "2020",
        artURL: new URL("../images/implementation.jpg", import.meta.url).href,
    },
    {
        artist: "girls rituals",
        album: "crap shit",
        year: "2020",
        artURL: new URL("../images/crap-shit.jpg", import.meta.url).href,
    },
    {
        artist: "wowaka",
        album: "unhappy refrain",
        year: "2011",
        artURL: new URL("../images/unhappy-refrain.jpg", import.meta.url).href,
    },
    {
        artist: "vylet pony",
        album: "cutiemarks",
        year: "2021",
        artURL: new URL("../images/cutiemarks.jpg", import.meta.url).href,
    },
    {
        artist: "iglooghost",
        album: "Neō Wax Bloom",
        year: "2017",
        artURL: new URL("../images/neo-wax-bloom.jpg", import.meta.url).href,
    },
    {
        artist: "Tyler, the Creator",
        album: "CALL ME IF YOU GET LOST",
        year: "2021",
        artURL: new URL("../images/cmiygl.jpg", import.meta.url).href,
    },
    {
        album: "ULTRAPOP",
        artist: "The Armed",
        year: "2021",
        artURL: new URL("../images/ultrapop.jpg", import.meta.url).href,
    },
];

export function getRandomMeta(): Metadata {
    return defaultMetas[Math.floor(Math.random() * defaultMetas.length)];
}
